<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')" :maxWidth="dialogWidth">
      <template v-slot:title>
        {{ data.id ? data.name : "Новая запись в справочнике [" + dir.text + "]" }}
        <small v-if="id"> ({{ id }})</small>
      </template>

      <a-form-model2
        v-model="data"
        :model="model"
        :modelForm="modelForm"
        :readonly="!canEdit"
        :config="defaults"
        :errors="errors"
        @validate="
          doWatch($event);
          validate($event);
        "
        @fieldData="setFieldData($event)"
      />
      <a-table-f-api-post
        style="height: 300px; margin-top: 15px"
        ref="table"
        :apiPost="{
          api: '/report_sql/filters',
          params: {
            name: `goods_getEveragePrice_detail`,
            params: {
              date_start: $parent.dateStart,
              date_end: $parent.dateEnd,
              id,
            },
          },
        }"
        :model="modelP"
        :useQuery="false"
        @setCheckbox="onClickRow($event)"
      />
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save @click="submit_()" :disabled="!(canEdit || !id)"></a-btn-save>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, keyDetect, getAccess, genModel } from "@/components/mixings";

export default {
  mixins: [getForm, submitForm, removeEl, keyDetect, getAccess, genModel],
  props: {
    value: Boolean,
    id: Number,
    defaults: {
      type: Object,
      default: () => {
        return { dense: true, hideDetails: "auto" };
      },
    },
    dir: {
      type: Object,
      default: () => {},
    },
    api: String,
  },
  data() {
    return {
      m: this.$store.getters["config/get"].models.dirs,
      removeDialogShow: false,
      modelForm: null,
      watchField: null,
      watchValue: null,
      needCalcModel: 1,
      afterSaveAction: null,
      suEditShow: false,
      model: [],
      data_: null,
    };
  },
  computed: {
    modelP() {
      return [
        { name: "checked", type: "checkbox", width: 35 },
        { name: "code_doc", title: "Заказ", type: "string", sortable: true, width: 50 },
        { name: "date_doc", title: "Дата", type: "date", sortable: true, width: 80 },
        { name: "name", title: "Название", type: "string", sortable: true, width: 300, style: "white-space: normal;" },
        { name: "amount_real", title: "Кол-во", type: "number", sortable: true, width: 80 },
        { name: "price_real", title: "Цена", type: "number", sortable: true, width: 80 },
        { name: "object_code", title: "Объект", type: "select", dir: "object", sortable: true, width: 280, style: "white-space: normal;" },
        { name: "createdby_id", title: "Автор", type: "select", dir: "user", sortable: true, width: 180 },
      ];
    },
    paramsApi() {
      return this.$parent.paramsApi;
    },
    dialogWidth() {
      return (this.dir?.dialogWidth || 1200) + "px";
    },

    canEdit() {
      let res =
        this.getAccess("dirs." + this.dir.name + ".edit") ||
        (this.getAccess("dirs." + this.dir.name + ".create") && (this.data.createdby_id == this.$root.profile.id || !this.id));
      if (!res) {
        if ((new Date() - new Date(this.data.createdon)) / 1000 / 60 < 15) res = true;
      }
      return res;
    },
    canDelete() {
      let res = this.getAccess("dirs." + this.dir.name + ".delete");
      return res;
    },
  },
  watch: {
    "data.price_business"(v) {
      this.calcPrice(v);
    },
    data: {
      handler(newVal, oldVal) {
        if (!this.watchField) return;
        if (newVal[this.watchField] !== oldVal[this.watchField]) {
          this.getModel();
          this.needCalcModel++;
          return;
        }
        if (newVal[this.watchField] !== this.watchValue) {
          this.getModel();
          this.watchValue = newVal[this.watchField];
          this.needCalcModel++;
        }
      },
      deep: true,
    },
    value() {
      if (this.value) {
        this.updateData(this.id);
      }
    },
  },
  created() {
    this.updateData(this.id);
    if (!this.id) {
      ///  this.type = 1;
      //  this.data.status = 0;
    }
  },
  methods: {
    async onClickRow(d) {
      let p = 0;
      for (let row of d.filter((el) => {
        return el?.checked;
      })) {
        p += row.price_real / (row.amount_real || 1);
      }
      p = Math.round(p);
      if (!p) p = this.data_.price_business;

      this.calcPrice(p);
    },
    calcPrice(p) {
      this.data.price_business = p;
      const ratio = p / this.data_.price_business;
      this.data.price_comfort = Math.round(this.data_.price_comfort * ratio);
      this.data.price_premium = Math.round(this.data_.price_premium * ratio);
    },

    doWatch(e) {
      if (e == this.m[this.dir.name]?.config?.watch) this.getModel(this.data?.[e]);
      //console.log("doWatch", e, this.config, this.model);
    },

    getModel(t) {
      // if (!this.needCalcModel) return {};
      const name = this.dir?.name || null;
      if (!name) return {};
      let m;
      if (this.dir?.model && typeof this.dir?.model == "string" && this.$store.getters["config/get"].models?.[this.dir.model]) {
        m = Object.assign({}, this.$store.getters["config/get"].models[this.dir.model]);
      }
      if (!m) m = JSON.parse(JSON.stringify(this.m[name]));
      this.modelForm = null;
      this.model = [];
      m = {
        form: [
          { name: "name", title: "Название", type: "string", validator: ["req"] },
          { name: "price_comfort", title: "Цена (комфорт)", type: "number", validator: ["req"], size: 4 },
          { name: "price_business", title: "Цена (бизнес)", type: "number", validator: ["req"], size: 4 },
          { name: "price_premium", title: "Цена (премиум)", type: "number", validator: ["req"], size: 4 },
        ],
        config: {
          default: {
            fields:
              "name,category_id,rooms_types,measure,price_comfort,price_business,price_premium,status,data.comment_price_comfort,data.comment_price_business,data.comment_price_premium",
            fieldsRO: "name",
            fieldsForm: "name,price_comfort#4,price_business#4,price_premium#4",
          },
        },
      };
      this.afterSaveAction = m?.afterSave || null;
      let model = this.getModelList(m, "form", true);
      let fieldsForm = [];
      let modelForm = [];
      model.forEach((el) => {
        if (!this.id && el?.hiddenCreate) {
          el.hidden = true;
        }
        fieldsForm.push(el.name);
      });
      this.watchModel = null;
      this.watchField = null;
      if (m.config) {
        const conf = m.config || [];
        const f = conf.configField;
        let config;
        let def = conf.default;
        if (f) {
          this.watchField = f;
          config = (conf?.config || []).find((el) => {
            if (Array.isArray(el.value)) return el.value.includes(this.data[f]);
            return el.value == this.data[f];
          });
          if (config === undefined) config = def;
        } else {
          config = def;
        }
        this.watchModel = config?.watch || null;
        const fields = config?.fields ? config.fields.split(",") : [];
        fieldsForm = config?.fieldsForm ? config.fieldsForm.split(",") : fieldsForm;
        if (fields.length) {
          model = model.filter((el) => fields.includes(el.name)).copy();
          let mod = model.filter((el) => fields.includes(el.name)).copy();
          this.fillFormValidators(mod);
          // model = model.filter((el) => fields.includes(el.name));
        }
      }
      fieldsForm.forEach((field) => {
        let s = field.split("#");
        modelForm.push({ name: s[0], size: s[1] || 12 });
      });
      this.fillFormFromModel(model);
      this.model = model;
      this.modelForm = [...modelForm];
    },
    async submit_() {
      this.submit(false, "id,price_comfort,price_business,price_premium");
    },
    afterFetchData(data) {
      this.data_ = Object.assign({}, this.data);
      this.needCalcModel++;
      this.getModel();
    },

    afterSave(data, status) {
      if (status) this.$emit("input");
    },
  },
};
</script>
